import { useEffect, useState } from "react";
import "./manageuserform.css";
import { useLocation, useNavigate } from 'react-router-dom';
import HttpClient from '../utils/HttpClient';
import toast from "react-hot-toast";

const ManageUserNavigate = () => {

    const initial = {
        firstName: "",
        lastName: "",
        emailID: "",
        phone: "",
        password: "",
        organizationName: "",
        address: ""
    }
    const navigate = useNavigate();
    const [addUsers, setAddUsers] = useState(initial)
    const [showPassword, setShowPassword] = useState(false);
    const [image, setImage] = useState("");
    const [isEdit, setIsEdit] = useState(false)
    const locattion = useLocation()
    const locationState = locattion?.state
    console.log("Editinguserdata", locationState)

    // >>>>Back To User Page<<<<
    const backPage = () => {
        navigate(-1);
    };

    // >>>>Handle Change<<<<
    const handleChange = (e) => {
        const { name, value } = e.target;
        setAddUsers({ ...addUsers, [name]: value })
    }

    // >>>>Handle IMage Changes<<<<
    const handleImageChange = async (e) => {
        let file = e.target.files[0];
        console.log("filewa", file);
        if (!file) {
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            toast.error("Image size must be less than 5 MB");
            return;
        }

        let formData = new FormData();
        formData.append("image", file);
        console.log([...formData.entries()]);

        try {
            let res = await HttpClient.fileUplode("image-upload", "POST", formData);
            // console.log("reswassssss",res)
            if (res && res.status) {
                toast.success("Image Uploaded Successfully");
                setImage(res?.url);  // Assuming res.url contains the URL of the uploaded image
            } else {
                toast.error(res?.message || "Something went wrong");
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            toast.error("Error uploading file");
        }
    };

    // >>>>Handle Remove Images<<<<
    const handleRemoveImage = () => {
        setImage("");
        document.getElementById("profilePic").value = "";
    };

    // >>>>Handle Validation Of All Input<<<<
    const validate = () => {
        const { firstName, lastName, password, emailID, phone, organizationName, address } = addUsers;
        const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        const phoneRegex = /^\d{10}$/;

        if (!firstName) {
            toast.error("First Name is required");
            return true;
        }
        if (!lastName) {
            toast.error("Last Name is required");
            return true;
        }
        if (!password) {
            toast.error("Password is required");
            return true;
        }
        if (!emailID) {
            toast.error("Email is required");
            return true;
        }
        if (!emailID.match(mailFormat)) {
            toast.error("Please Enter Valid Email..!");
            return true;
        }
        if (!phone) {
            toast.error("Phone Number is required");
            return true;
        }
        if (!phoneRegex.test(phone)) {
            toast.error("Please Enter Valid (10 digits) Mobile Number..!");
            return true;
        }
        if (!organizationName) {
            toast.error("Organization Name is required");
            return true;
        }
        if (!address) {
            toast.error("Address is required");
            return true;
        }
        // if (!image) {
        //     toast.error("Profile Picture is required");
        //     return true;
        // }
        return false;
    };

    // >>>>Handle Submit<<<<
    const handleSubmit = async (e) => {
        e.preventDefault();
        const { firstName, lastName, password, emailID, phone, organizationName, address } = addUsers;
        const id = locationState?._id
        if (validate()) {
            return;
        }
        const data = {
            firstName,
            lastName,
            emailID,
            password,
            organizationName,
            address,
            phone,
            image: "",
        };
        if (isEdit) {
            const res = await HttpClient.requestData(`user-update/${id}`, "PUT", data);
            console.log("sending all data", data);
            if (res && res?.status) {
                toast.success(res?.message || "User data updates successfully");
                setImage("");
                setAddUsers(initial)
                navigate('/manageusers')
            } else {
                return toast.error(res?.message || "Something went wrong...!")
            }
        } else {
            const res = await HttpClient.requestData("add-user", "POST", data);
            console.log("sending all data", data);
            if (res && res?.status) {
                toast.success(res?.message || "User data added successfully");
                setImage("");
                setAddUsers(initial)
                navigate('/manageusers')
            } else {
                return toast.error(res?.message || "Something went wrong...!")
            }
        }

    };

    // >>>>Setting Data
    useEffect(() => {
        if (locationState) {
            setAddUsers(locationState)
            setIsEdit(true)
        } else {
            setIsEdit(false)
        }
    }, [locationState])

    return (
        <div className='userForm'>
            <div className="header">
                <b style={{ fontSize: "20px", fontWeight: "400", cursor: "pointer" }}>{isEdit ? "Update User" : "Add User"}</b>
                <b style={{ cursor: "pointer", color: "rgb(208, 38, 38)" }} onClick={backPage}>
                    <i className="fas fa-arrow-left" style={{ marginRight: '8px' }}></i>
                    Back
                </b>
            </div>

            {/* form started--------- */}
            <div className='userFormDiv'>
                <form onSubmit={handleSubmit}>
                    <div className='formHeader'>

                        {/* First Name */}
                        <div>
                            First Name<br /><br />
                            <input
                                type="text"
                                placeholder="First Name"
                                name="firstName"
                                value={addUsers?.firstName}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Last Name */}
                        <div>
                            Last Name<br /><br />
                            <input
                                type="text"
                                placeholder="Last Name"
                                name="lastName"
                                value={addUsers?.lastName}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Password */}
                        <div>
                            Password<br /><br />
                            <div style={{ position: 'relative' }}>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter Password"
                                    name="password"
                                    value={addUsers?.password}
                                    onChange={handleChange}
                                    style={{ paddingRight: '30px' }}
                                />
                                <i
                                    className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                    }}
                                ></i>
                            </div>
                        </div>
                    </div>

                    {/* Email */}
                    <div className='formFoot'>
                        <div>
                            Email<br /><br />
                            <input
                                type="text"
                                placeholder="Email"
                                name="emailID"
                                value={addUsers?.emailID}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Phone */}
                        <div><br />
                            Phone Number<br /><br />
                            <input
                                type="number"
                                placeholder="Phone Number"
                                name="phone"
                                value={addUsers?.phone}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Organization Name */}
                        <div><br />
                            Organization Name<br /><br />
                            <input
                                type="text"
                                placeholder="Organization Name"
                                name="organizationName"
                                value={addUsers?.organizationName}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Address */}
                        <div><br />
                            <label htmlFor="address">Address:</label><br />
                            <textarea
                                id="address"
                                placeholder="Write Your Address here..."
                                name="address"
                                value={addUsers?.address}
                                onChange={handleChange}
                                className="px-2 pt-3"
                            ></textarea>
                        </div>
                    </div>

                    {/* Profile Picture */}
                    <div className="file">
                        Profile Picture<br />
                        <input
                            type="file"
                            id="profilePic"
                            className="fileInput"
                            onChange={(e) => handleImageChange(e)}
                        />
                        <label htmlFor="profilePic">Upload Profile Picture <i className="fas fa-upload"></i></label>

                        {/* Submit Button */}
                        <button style={{ backgroundColor: "rgb(208, 38, 38)" }} type="submit">{isEdit ? "Update" : "Save"}</button>
                    </div>

                </form>
            </div>
            {/* form ended----------- */}

            {/* Footer */}
            <footer style={{ textAlign: "", marginTop: "20px" }}>
                <p style={{ fontSize: "12px", color: "#666" }}>Copyright © 2024 Psedge. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default ManageUserNavigate;
